export const norm = (v?: string) => (v || '').trim().toUpperCase()

export const checkTerminalChangeRequired = (arrival: any, departure: any) => {
  const arrCode = norm(arrival?.airport?.code)
  const depCode = norm(departure?.airport?.code)
  if (!arrCode || !depCode || arrCode !== depCode) return ''
  const arrTerm = norm(arrival?.airport?.terminal?.name)
  const depTerm = norm(departure?.airport?.terminal?.name)
  return arrTerm && depTerm && arrTerm !== depTerm ? `Change to terminal ${depTerm}` : ''
}

export const checkAirportChangeRequired = (
  arrival: any,
  departure: any,
  airportDetail?: Record<string, any>
) => {
  const arrCode = norm(arrival?.airport?.code)
  const depCode = norm(departure?.airport?.code)
  if (!(arrCode && depCode && arrCode !== depCode)) return ''
  const airportCity = airportDetail?.[depCode]?.city
  return `Airport Change in ${airportCity || depCode}`
}

export const getChangeInfo = (
  arrival: any,
  departure: any,
  airportDetail?: Record<string, any>
) => {
  const airportMsg = checkAirportChangeRequired(arrival, departure, airportDetail)
  const terminalMsg = airportMsg ? '' : checkTerminalChangeRequired(arrival, departure)
  return {
    airportChange: !!airportMsg,
    terminalChange: !!terminalMsg,
    message: airportMsg || terminalMsg || ''
  }
}

// Transit visa: match arrival airport code with layoverInfo entries
export const getTransitVisaRequired = (arrival: any, layoverInfo: any): boolean => {
  try {
    const layovers = Array.isArray(layoverInfo) ? layoverInfo : []
    const match = layovers.find((l: any) => l?.airport === norm(arrival?.airport?.code))
    return !!(match && typeof match.transitVisaRequired === 'boolean' && match.transitVisaRequired)
  } catch (e) {
    return false
  }
}


